import styled from "styled-components";
import { CenterFlexColumn } from "styles/layout";
import { Theme } from "theme";

export const FormatContainer = styled(CenterFlexColumn)`
  width: 50px;
  row-gap: 2px;
  color: ${Theme.panelForegroundLight};
`;
